import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export default function Gallery({ images = [], label = "Gallery" }) {
  const [idx, setIdx] = useState(null);
  if (!images.length) return null;
  const open = idx !== null;
  const prev = () => setIdx((i) => (i - 1 + images.length) % images.length);
  const next = () => setIdx((i) => (i + 1) % images.length);

  return (
    <div data-testid="gallery">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {images.map((src, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            data-testid={`gallery-thumb-${i}`}
            className={`group relative overflow-hidden rounded-2xl ${i === 0 ? "col-span-2 row-span-2 aspect-square md:aspect-[4/3]" : "aspect-square"}`}
          >
            <img src={src} alt={`${label} ${i + 1}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-nead-ink/0 group-hover:bg-nead-ink/20 transition-colors" />
          </button>
        ))}
      </div>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4" onClick={() => setIdx(null)} data-testid="gallery-lightbox">
            <button onClick={() => setIdx(null)} className="absolute top-5 right-5 text-white/70 hover:text-white" data-testid="gallery-close"><X className="h-7 w-7" /></button>
            <button onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-4 md:left-8 text-white/70 hover:text-white"><ChevronLeft className="h-9 w-9" /></button>
            <motion.img
              key={idx}
              initial={{ opacity: 0, scale: 0.96 }}
              animate={{ opacity: 1, scale: 1 }}
              src={images[idx]}
              alt={`${label} ${idx + 1}`}
              className="max-h-[85vh] max-w-[90vw] rounded-2xl object-contain"
              onClick={(e) => e.stopPropagation()}
            />
            <button onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-4 md:right-8 text-white/70 hover:text-white"><ChevronRight className="h-9 w-9" /></button>
            <div className="absolute bottom-6 text-white/60 text-sm">{idx + 1} / {images.length}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
